// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { _x } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-loop-menu-button-support' )
export class AutomatorBuilderLoopMenuButtonSupport extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) accessor iterableExpression;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				href=${ this.supportURL }
				target="_blank"
			>
				${ escapeHTML( _x( 'Support', 'Noun', 'uncanny-automator' ) ) }
			</uo-button>
		`;
	}

	/**
	 * Get the URL of the support page based on the type of the iterable expression
	 *
	 * @return {String|undefined} The URL of the support page
	 */
	get supportURL() {
		if ( this.iterableExpression?.type === 'users' ) {
			return UncannyAutomator._site.automator.links.loops_guide.users_loops;
		}

		if ( this.iterableExpression?.type === 'posts' ) {
			return UncannyAutomator._site.automator.links.loops_guide.posts_loops;
		}

		if ( this.iterableExpression?.type === 'token' ) {
			return UncannyAutomator._site.automator.links.loops_guide.token_loops;
		}
	}
}
